import type { ICityFields, ICountryFields } from 'types/contentful/generated';

/**
 * Get country and city data from Contentful City content type
 */
export const getCountryAndCity = (
  city: Omit<ICityFields, 'country'> & {
    country: ICountryFields;
  },
): { city?: string; country: ICountryFields } => {
  return {
    city: city.name,
    country: {
      name: city.country.name,
      acronym: city.country.acronym,
    },
  };
};
